{
  "familyId": "TOPO-EU-HOOFDST",
  "questions": [
    {
      "id": "TOPO-EU-HOOFDST-001",
      "familyId": "TOPO-EU-HOOFDST",
      "module": "Topo",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_hoofdsteden_eu",
      "questionType": "multiple_choice",
      "question": "Een diplomaat reist naar de hoofdstad van het Verenigd Koninkrijk. Naar welke stad gaat hij?",
      "options": ["Londen", "Edinburgh", "Manchester", "Dublin"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Hoofdstad Verenigd Koninkrijk", "content": "Londen is de hoofdstad van het Verenigd Koninkrijk. Edinburgh is de hoofdstad van Schotland (een deel van het VK). Dublin is de hoofdstad van Ierland (een ander land).", "icon": "lightbulb"}}],
      "conceptId": "eu_capital_uk",
      "variantIndex": 1,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.82,
      "feedback": {
        "explanationText": "Londen is de hoofdstad van het Verenigd Koninkrijk. Het VK bestaat uit Engeland, Schotland, Wales en Noord-Ierland. Londen ligt in Engeland, aan de rivier de Theems.",
        "solutionSteps": ["Het Verenigd Koninkrijk = Engeland + Schotland + Wales + Noord-Ierland", "De hoofdstad is Londen", "Londen ligt aan de Theems in Engeland"],
        "distractorExplanations": {
          "0": "Goed! Londen is de hoofdstad van het Verenigd Koninkrijk.",
          "1": "Edinburgh is de hoofdstad van Schotland, een deel van het VK. Maar de hoofdstad van het hele VK is Londen. Onthoud: Edinburgh = Schotland, Londen = VK.",
          "2": "Manchester is een grote stad in Engeland, maar niet de hoofdstad. Onthoud: grote stad ≠ hoofdstad.",
          "3": "Dublin is de hoofdstad van Ierland (de Republiek Ierland), niet van het Verenigd Koninkrijk. Onthoud: Ierland en het VK zijn twee verschillende landen."
        }
      }
    },
    {
      "id": "TOPO-EU-HOOFDST-002",
      "familyId": "TOPO-EU-HOOFDST",
      "module": "Topo",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_hoofdsteden_eu",
      "questionType": "multiple_choice",
      "question": "Een journalist reist naar de Griekse hoofdstad. Waar gaat ze naartoe?",
      "options": ["Athene", "Thessaloniki", "Kreta", "Istanbul"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Hoofdstad van Griekenland", "content": "Athene is de hoofdstad van Griekenland. Het is een van de oudste steden ter wereld. Istanbul ligt in Turkije, niet in Griekenland.", "icon": "lightbulb"}}],
      "conceptId": "eu_capital_greece",
      "variantIndex": 2,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.79,
      "feedback": {
        "explanationText": "Athene is de hoofdstad van Griekenland. Het is een van de oudste steden ter wereld, beroemd om de Akropolis en het Parthenon.",
        "solutionSteps": ["Griekenland ligt in Zuid-Europa", "De hoofdstad is Athene", "Athene is beroemd om de Akropolis"],
        "distractorExplanations": {
          "0": "Goed! Athene is de hoofdstad van Griekenland.",
          "1": "Thessaloniki is de op één na grootste stad van Griekenland, in het noorden. Maar de hoofdstad is Athene. Onthoud: de grootste stad is niet altijd de hoofdstad — maar in dit geval is Athene beide.",
          "2": "Kreta is een eiland van Griekenland, geen stad. De hoofdstad van Kreta is Heraklion, maar de hoofdstad van heel Griekenland is Athene.",
          "3": "Istanbul ligt in Turkije, niet in Griekenland. Vroeger heette het Constantinopel en was het de hoofdstad van het Byzantijnse Rijk. Onthoud: Istanbul = Turkije, Athene = Griekenland."
        }
      }
    },
    {
      "id": "TOPO-EU-HOOFDST-003",
      "familyId": "TOPO-EU-HOOFDST",
      "module": "Topo",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_hoofdsteden_eu",
      "questionType": "multiple_choice",
      "question": "Welke stad is de hoofdstad van Zweden?",
      "options": ["Stockholm", "Oslo", "Helsinki", "Kopenhagen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Scandinavische hoofdsteden", "content": "Stockholm = Zweden, Oslo = Noorwegen, Helsinki = Finland, Kopenhagen = Denemarken. Onthoud: SHOK — Stockholm, Helsinki, Oslo, Kopenhagen.", "icon": "lightbulb"}}],
      "conceptId": "eu_capital_scandinavia",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Stockholm is de hoofdstad van Zweden. De Scandinavische hoofdsteden worden vaak verward. Ezelsbruggetje: Stockholm = Zweden, Oslo = Noorwegen, Helsinki = Finland, Kopenhagen = Denemarken.",
        "solutionSteps": ["Zweden ligt in Noord-Europa (Scandinavië)", "De hoofdstad is Stockholm", "Ezelsbruggetje: Stockholm = Zweden"],
        "distractorExplanations": {
          "0": "Goed! Stockholm is de hoofdstad van Zweden.",
          "1": "Oslo is de hoofdstad van Noorwegen, niet van Zweden. Noorwegen en Zweden zijn buurlanden, maar hebben verschillende hoofdsteden. Onthoud: Oslo = Noorwegen.",
          "2": "Helsinki is de hoofdstad van Finland, niet van Zweden. Finland ligt ten oosten van Zweden. Onthoud: Helsinki = Finland.",
          "3": "Kopenhagen is de hoofdstad van Denemarken, niet van Zweden. Denemarken ligt ten zuiden van Zweden. Onthoud: Kopenhagen = Denemarken."
        }
      }
    },
    {
      "id": "TOPO-EU-HOOFDST-004",
      "familyId": "TOPO-EU-HOOFDST",
      "module": "Topo",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_hoofdsteden_eu",
      "questionType": "multiple_choice",
      "question": "Welke stad is NIET de hoofdstad van het land waar het in ligt?",
      "options": ["Barcelona (Spanje)", "Parijs (Frankrijk)", "Berlijn (Duitsland)", "Rome (Italië)"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Hoofdstad vs. bekendste stad", "content": "Barcelona is een grote stad in Spanje, maar de hoofdstad is Madrid. Parijs, Berlijn en Rome zijn wél de hoofdsteden van hun land.", "icon": "lightbulb"}}],
      "conceptId": "eu_capital_not_question",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Barcelona is een grote stad in Spanje, maar NIET de hoofdstad. De hoofdstad van Spanje is Madrid. Parijs = hoofdstad Frankrijk ✓, Berlijn = hoofdstad Duitsland ✓, Rome = hoofdstad Italië ✓.",
        "solutionSteps": ["Barcelona is een grote stad in Spanje, maar niet de hoofdstad", "De hoofdstad van Spanje is Madrid", "Parijs, Berlijn en Rome zijn wél hoofdsteden"],
        "distractorExplanations": {
          "0": "Goed! Barcelona is niet de hoofdstad van Spanje — dat is Madrid.",
          "1": "Parijs is wél de hoofdstad van Frankrijk. De vraag zoekt de stad die NIET de hoofdstad is. Onthoud: lees 'NIET'-vragen goed.",
          "2": "Berlijn is wél de hoofdstad van Duitsland. De vraag zoekt de stad die NIET de hoofdstad is.",
          "3": "Rome is wél de hoofdstad van Italië. De vraag zoekt de stad die NIET de hoofdstad is."
        }
      }
    },
    {
      "id": "TOPO-EU-HOOFDST-005",
      "familyId": "TOPO-EU-HOOFDST",
      "module": "Topo",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_hoofdsteden_eu",
      "questionType": "matching",
      "question": "Koppel elk Scandinavisch land aan de juiste hoofdstad.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {"left": "Zweden", "right": "Stockholm"},
          {"left": "Noorwegen", "right": "Oslo"},
          {"left": "Denemarken", "right": "Kopenhagen"},
          {"left": "Finland", "right": "Helsinki"}
        ]
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Scandinavische hoofdsteden", "content": "Zweden → Stockholm, Noorwegen → Oslo, Denemarken → Kopenhagen, Finland → Helsinki. Ezelsbruggetje: SHOK (Stockholm, Helsinki, Oslo, Kopenhagen).", "icon": "lightbulb"}}],
      "conceptId": "eu_capital_scandinavia_matching",
      "variantIndex": 5,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Zweden → Stockholm, Noorwegen → Oslo, Denemarken → Kopenhagen, Finland → Helsinki.",
        "solutionSteps": ["Zweden → Stockholm", "Noorwegen → Oslo", "Denemarken → Kopenhagen", "Finland → Helsinki"]
      }
    },
    {
      "id": "TOPO-EU-HOOFDST-007",
      "familyId": "TOPO-EU-HOOFDST",
      "module": "Topo",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_hoofdsteden_eu",
      "questionType": "true_false_series",
      "question": "Waar of onwaar? Beoordeel deze stellingen over Europese hoofdsteden.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          {"text": "Parijs is de hoofdstad van Frankrijk.", "isTrue": true},
          {"text": "Barcelona is de hoofdstad van Spanje.", "isTrue": false},
          {"text": "Berlijn is de hoofdstad van Duitsland.", "isTrue": true},
          {"text": "Milaan is de hoofdstad van Italië.", "isTrue": false}
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoofdsteden — let op!",
            "content": "De grootste stad is niet altijd de hoofdstad! Spanje: Madrid (niet Barcelona). Italië: Rome (niet Milaan). Turkije: Ankara (niet Istanbul). Australië: Canberra (niet Sydney).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "eu_capitals_true_false",
      "variantIndex": 7,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Parijs is inderdaad de hoofdstad van Frankrijk. Barcelona is de grootste stad van Catalonië, maar de hoofdstad van Spanje is Madrid. Berlijn is de hoofdstad van Duitsland. Milaan is de grootste stad van Noord-Italië, maar de hoofdstad van Italië is Rome.",
        "solutionSteps": [
          "Parijs = hoofdstad van Frankrijk (Waar)",
          "Barcelona is NIET de hoofdstad — Madrid is de hoofdstad van Spanje (Onwaar)",
          "Berlijn = hoofdstad van Duitsland (Waar)",
          "Milaan is NIET de hoofdstad — Rome is de hoofdstad van Italië (Onwaar)"
        ]
      }
    }
  ]
}